import { TimeInterval } from '@va/types/time-series';
import { inWebsiteTimezone } from '@va/util/helpers';

/**
 * Whether the last point of the chart is the day that is currently in progress.
 *
 * The intervals are day boundaries in the website timezone, so the comparison happens there - in a browser
 * timezone behind the website one, midnight of the website day falls on the previous browser day and today
 * would look like it is not on the chart. @see inWebsiteTimezone
 */
export const chartIncludesToday = (currentTimeIntervals: TimeInterval[]): boolean => {
  const lastInterval = currentTimeIntervals[currentTimeIntervals.length - 1];
  if (!lastInterval) return false;

  const today = inWebsiteTimezone();

  return (
    !today.isBefore(inWebsiteTimezone(lastInterval.from), 'day') &&
    !today.isAfter(inWebsiteTimezone(lastInterval.until), 'day')
  );
};
